<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw" epub:type="frontmatter dedication" id="Dedication1">
<div class="block-rw dedication-rw" id="dedication1">
<p class="ded-rw" id="p25"><span>For R. </span></p>
<p class="ded-rw" id="p26"><span>And R.</span></p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s004-Dedication-01.vue?5792fb0c